import React from 'react'
import { TeamMember } from './'
const TeamMembers = ({ teamMembers }) => {
	return (
		<div>
			{teamMembers.map((tm) => (
				<TeamMember key={tm.name} {...tm} />
			))}
			<style jsx>{`
				div {
					display: grid;
					grid-template-columns: repeat(3, 1fr);
				}

				@media (max-width: 768px), (pointer: coarse) {
					div {
						display: block;
					}
				}
			`}</style>
		</div>
	)
}

export default TeamMembers
